/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.inappropriateContentModule')
  .service(
    'BulbInappropriateContentService',
    ['$modalStack', '$translate', 'BulbBusyCoverService', 'BulbModalService', 'Restangular',
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      BulbInappropriateContentService,
    ],
  );

function BulbInappropriateContentService($modalStack, $translate, BulbBusyCoverService, BulbModalService, Restangular) {
  const that = this;

  this.getType = function getType(unit) {
    // get unit type
    let type;
    // eslint-disable-next-line default-case
    switch (unit['@c']) {
      case '.PageUnitDTO':
        type = 'page';
        break;
      case '.CompositeUnitDTO':
        type = 'collection';
        break;
      case '.UserUnitDTO':
        type = 'profile';
        break;
      case '.GroupDTO':
        type = 'group';
        break;
    }
    return type;
  };

  this.openModal = function openModal($event, unit) {
    // get unit type
    const type = that.getType(unit);

    // modal
    $translate('inappropriate_content_modal_title', {
      type,
    }).then((title) => {
      const modalOptions = {
        fontAwesomeCode: 'fas fa-exclamation-triangle',
        titleText: title,
        showOkButton: false,
        showCancelButton: false,
        templateUrl: 'ajs/components/inappropriatecontent/inappropriatecontent-modal.html',
        windowClass: 'bulb-aero-modal-body report-modal',
        controller: ['$scope', function inappropriatecontentModalController($scope) {
          $scope.formData = {
            reason: null,
            details: null,
          };

          $scope.reasons = ['Inappropriate Content', 'Inaccurate Content',
            'Copyright Infringement', 'Spam', 'Other']; // TODO clean: we should translate these.

          $scope.close = (event) => BulbModalService.cancel(event);

          $scope.report = function report() {
            const top = $modalStack.getTop();
            $modalStack.close(top.key);
            BulbBusyCoverService.showBusyDuring(
              Restangular.all('inappropriatecontent').all('report').one(type, unit.id).post('', {
                reason: $scope.formData.reason,
                details: $scope.formData.details,
              })
                .then(() => {
                  BulbModalService.showMessage('inappropriate_content_report_success');
                }, () => {
                  BulbModalService.showMessage('inappropriate_content_report_error');
                }),
            );
          };
        }],
        focusAfterClosed: $event.currentTarget,
      };
      BulbModalService.open(modalOptions);
    });
  };
}
